/* global document */
'use strict';

import merge from './merge';
import log from './logger';

/**
 * Parse JSON object from elements.
 * e.g. from <script> elements for a specific fragment.
 * @example
 * <script v-few-frg-loader-i18n="angular-app-v-coverage-map" type="application/json">
 * { "COVERAGEMAP": { "EXT_COVERAGE_TITLE": "Constatez notre large couverture"} }
 * </script>
 */
export default function parseJSON(selector) {
    const elems = document.querySelectorAll(selector);
    const obj = {};

    if (elems) {
        for (let i = 0; i < elems.length; i++) {
            try {
                merge(obj, JSON.parse(elems[i].innerHTML || '{}'));
            } catch (e) {
                log.warn('Error parsing JSON', e);
            }
        }
    }

    return obj;
}
